import { render, staticRenderFns } from "./WxMsg.vue?vue&type=template&id=40802fdd&scoped=true"
import script from "./WxMsg.vue?vue&type=script&lang=js"
export * from "./WxMsg.vue?vue&type=script&lang=js"
import style0 from "./WxMsg.vue?vue&type=style&index=0&id=40802fdd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40802fdd",
  null
  
)

export default component.exports